import logger from "../common/Logger";
import ApiService from "./ApiService";
import {defaultTenantId} from "./TenantService";

class MocksStatusService {
    constructor() {
        this.fetchMocksStatus = this.fetchMocksStatus.bind(this);
    }

    fetchMocks(callback) {
        ApiService.makeRequest(`/api/mocks`, {
            type: 'GET',
            success: (mocks) => {
                logger.info(`Mocks:`, mocks);
                callback(mocks);
            },
            error: (result, err) => {
                logger.error('Error fetching mocks:', err);
                callback(null, err);
            }
        });
    }

    fetchMocksStatus(mockId = defaultTenantId, callback) {
        ApiService.makeRequest(`/api/mocks/${mockId}/status`, {
            type: 'GET',
            success: (mock) => {
                logger.info(`Mock status: ${mock.status}`);
                callback(mock);
            },
            error: (result, err) => {
                logger.error('Error fetching mock status:', err);
                callback(null, err);
            }
        });
    }
}

export default new MocksStatusService();



// WEBPACK FOOTER //
// ./src/modules/service/MocksStatusService.js